import { render, staticRenderFns } from "./ParsingOverlay.vue?vue&type=template&id=c63bd5aa&scoped=true"
import script from "./ParsingOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParsingOverlay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ParsingOverlay.vue?vue&type=style&index=0&id=c63bd5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63bd5aa",
  null
  
)

export default component.exports